import { useContext } from "react";
import { ArrayField, AutocompleteInput, BooleanField, ChipField, CreateButton, Datagrid, DateField, FilterButton, List, ReferenceInput, sanitizeListRestProps, SearchInput, SelectInput, SingleFieldList, TextField, TopToolbar, useListContext, useRedirect } from "react-admin";
import { AppContext } from '../../providers/app-context-provider/app.context';
import { ProfileEnum } from "../../utils/general-profile.enum";
const SchoolActivityList = (props) => {

    const redirect = useRedirect()
    const context = useContext(AppContext)
    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN
    const profile = context.profile

    const institutionBranchFilter = (
        <ReferenceInput
            label='Unidade'
            source="institution_branch"
            reference="institution-branches"
            sort={{ field: context.profile.name === ProfileEnum.SUPERADMIN ? 'institution.name' : 'name', order: 'ASC' }}
            perPage={99}
            alwaysOn
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                optionText={record => context.profile.name === ProfileEnum.SUPERADMIN ? `${record?.institution?.name} - ${record?.name}` : record?.name}
            />
        </ReferenceInput>
    )

    const institutionFilter = (
        <ReferenceInput
            label="Instituição"
            source="institution"
            reference="institutions"
            filterToQuery={(text) => ({ "institution.name": text })}
            sort={{ field: 'institution.name', order: 'ASC' }}
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                emptyText="Todas"
                fullWidth
            />
        </ReferenceInput>
    )

    const listFilters = [
        <SearchInput placeholder="Nome" source="name" alwaysOn />,
        <SelectInput label="Status" source="has_started" choices={[{ name: "Em andamento", id: "true" }, { name: "Não iniciadas", id: "false" }]} alwaysOn />,
        <SelectInput label="Período letivo" source="academic_period" emptyText={"Todos"} emptyValue={"all"} choices={[{ name: "Vigente", id: "current" }]} alwaysOn />,
        <ReferenceInput
            label="Área"
            source="theme"
            reference="themes"
            sort={{ field: "name", order: "ASC" }}
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                emptyText="Todos"
                fullWidth
            />
        </ReferenceInput>
    ]

    const CustomActions = (props) => {
        const {
            className,
            exporter,
            filters,
            maxResults,
            ...rest
        } = props;
        const {
            basePath,
        } = useListContext();
        return (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                <FilterButton />
                {(
                    context.profile.name !== ProfileEnum.GENERAL_PRINCIPAL &&
                    context.profile.name !== ProfileEnum.ADMIN
                ) && <CreateButton basePath={basePath} />}
            </TopToolbar>
        );
    }

    if (superAdmin || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) {
        listFilters.push(institutionBranchFilter)
    }

    if (superAdmin) {
        listFilters.push(institutionFilter)
    }

    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            sort={{ field: 'end_date', order: 'DESC' }}
            filter={profile.name === ProfileEnum.TEACHER ? { "teacher.id": context.currentUser.id } : null}
            filters={listFilters}
            filterDefaultValues={{ has_started: true, academic_period: "current" }}
            actions={<CustomActions />}
            {...props}
        >
            <Datagrid rowClick={(id, basepath, record) => redirect(`/school-activity-dashboard/${id}`)}>
                <TextField source="name" label="Nome" />
                <TextField source="class.name" label="Turma" />
                <ArrayField source="teachers" label="Professores responsáveis"><SingleFieldList linkType={false}><ChipField source="user.name" /></SingleFieldList></ArrayField>
                <ArrayField source="themes" label={"Áreas de conhecimento"}><SingleFieldList linkType={false}><ChipField source="name" /></SingleFieldList></ArrayField>
                <BooleanField source="has_started" label="Em andamento?" />
                <DateField source="start_date" label="Data de início" emptyText="-" />
                <DateField source="end_date" label="Término previsto" emptyText="-" />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            </Datagrid>
        </List>
    )
}

export default SchoolActivityList